<div class="flex h-full min-h-0 flex-col gap-4">
	<div class="mx-4 flex">
		<mat-form-field
			appearance="fill"
			class="mat-form-field-no-hint flex-auto"
		>
			<mat-label>{{ 'utils.search' | translate }}</mat-label>
			<input
				[cdkTrapFocusAutoCapture]="true"
				[formControl]="search"
				#searchElement
				cdkInitialFocus
				cdkTrapFocus
				ignoreAutocomplete
				matInput
				type="text"
			>
		</mat-form-field>
	</div>
	@if (entries$filtered | async; as entries) { @if (entries.length) {
	<div
		cdkVirtualScrollingElement
		class="scroll-y h-[500px] min-h-0"
	>
		<div class="h-full overflow-y-auto">
			@for (entry of entries; track entry.id) {
			<div>
				<div
					(click)="submitTask({ task: entry })"
					[ngClass]="{
                  'rounded-t-lg': $first && !$last,
                  'rounded-lg': $first && $last,
                  'rounded-b-lg': $last && !$first,
                  '!mat-bg-5-hover': !entry.selected,
                  '!mat-bg-2': entry.selected,
				  'border-t-2 border-muted-foreground/50': entry.showUnpinnedDivider,
                }"
					class="mx-4 flex min-h-10 cursor-pointer  items-center select-none space-x-2 px-4 py-0"
				>
					<div class="truncate-flex flex flex-auto flex-col space-y-2">
						<div class="flex flex-row gap-2">
							<h3 class="mb-0 truncate text-base">{{ entry.name | truncate: 100 }}</h3>
							<div class="!ml-auto flex flex-row items-center justify-start gap-2">
								<mat-icon
									[matTooltip]="'Billable_Alt' | translate"
									*ngIf="entry.billable"
									class="bg-accent-2 rounded-circle flex-none !p-1 text-lg"
									color="accent"
									inline
								>
									attach_money
								</mat-icon>
								<mat-icon
									[matTooltip]="'project.private.state' | translate"
									*ngIf="entry.private"
									class="bg-default-2 rounded-circle flex-none !p-1 text-lg"
									inline
								>
									lock
								</mat-icon>
							</div>
						</div>
						@if (showProjectClientLabel() !== false) {
						<div class="mat-hint flex items-center space-x-2">
							<span>{{
								entry.client | defaultEntityTranslate: 'client' : 'client.none' | truncate: 100
							}}</span>
							<span class="dot size-1.5"></span>
							<span>{{
								entry.project | defaultEntityTranslate: 'project' : 'project.none' | truncate: 100
							}}</span>
						</div>
						}
						<div
							[innerText]="desc | truncate: 200 | trim"
							*ngIf="entry.description as desc"
							class="mat-typography whitespace-pre-wrap"
						></div>
					</div>
					@if (entry.estimation > 0) {
					<app-estimation-statistics-graph
						[completed]="entry.completed"
						[estimation]="entry.estimation || 0"
						[recorded]="
                      entry.timesRecorded
                        ? (entry.timesRecorded.billable?.clamp(0, entry.timesRecorded.billable) || 0) +
                          (!selectedEntity.project?.billable
                            ? entry.timesRecorded.notBillable?.clamp(0, entry.timesRecorded.notBillable) || 0
                            : 0)
                        : 0
                    "
					></app-estimation-statistics-graph>
					}
					<button
						(click)="$event.stopPropagation(); openContextMenu($event, contextMenuTrigger, { entry: entry })"
						class="flex flex-col items-center justify-center"
						mat-icon-button
					>
						<mat-icon>more_vert</mat-icon>
					</button>
				</div>
			</div>
			}
		</div>
		<!-- <div class="pb-48"></div> -->
	</div>
	} @else {<ng-container *ngTemplateOutlet="noItems"></ng-container>} } @else {<ng-container
		*ngTemplateOutlet="noItems"
	></ng-container
	>}
</div>
<ng-template #noItems>
	<div class="flex h-[500px] min-h-0 flex-col items-center justify-center">
		{{ 'time.no-tasks-for-user' | translate }}
	</div>
</ng-template>

<mat-menu #itemContextMenu>
	<ng-template
		let-entry="entry"
		matMenuContent
	>
		<div class="flex flex-col space-y-2">
			<button
				(click)="this.togglePinTask(entry.id)"
				mat-menu-item
			>
				<mat-icon inline>star</mat-icon>
				{{ (entry.pinned ? 'project.fav-disable' : 'project.fav-enable') | translate }}
			</button>
			@if(entry.pinned && !entry.pinnedTop) {
			<button
				(click)="this.movePinnedTask(task.id)"
				mat-menu-item
			>
				<mat-icon inline>arrow_upward</mat-icon>
				{{ 'project.moveFavouriteToTop' | translate }}
			</button>
			}
			<a
				(click.prevent)="openProject(selectedEntity.project.id)"
				[disabled]="isDefaultProject$ | async"
				[routerLink]="['/settings/projects', selectedEntity.project.id]"
				mat-menu-item
			>
				<mat-icon inline>folder</mat-icon>
				{{ 'project.open' | translate }}
			</a>
		</div>
	</ng-template>
</mat-menu>
<div
	[matMenuTriggerFor]="itemContextMenu"
	[style.left]="projectMenuPosition.x"
	[style.top]="projectMenuPosition.y"
	#contextMenuTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
<ng-template
	#projectPickerTooltip
	let-project="project"
	let-tags="tags"
>
	<div class="my-2 flex flex-col space-y-2 px-2.5 wflex-[1_0_220px]">
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				client.single
			</h3>
			<div class="font-semibold">{{ project?.client | defaultEntityTranslate: 'client' : 'client.none' }}</div>
		</div>
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				project.single
			</h3>
			<div class="font-semibold">{{ project | defaultEntityTranslate: 'task' : 'task.none' }}</div>
		</div>
		<div
			*ngIf="project?.description as desc"
			class="space-y-1"
		>
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				Description
			</h3>
			<div>{{ desc | truncate: 120 }}</div>
		</div>
		<ng-container *ngIf="tags && tags.length > 0">
			<div class="space-y-1">
				<h3
					class="mat-hint text-sm italic"
					translate
				>
					tag.plural
				</h3>
				<div class="flex flex-wrap gap-2">
					<div
						*ngFor="let item of tags; trackBy: trackId"
						class="mbg-card pointer-events-none h-6 cursor-default select-none truncate rounded-full px-2.5 text-base leading-6"
					>
						{{ item.name }}
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</ng-template>
